<template>
    <v-container class="main-container responsive-height">
        <v-row dense>
            <v-col cols="12" xl="12">
                <LiveTradeTabs></LiveTradeTabs>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import LiveTradeTabs from "@/components/PagesComponents/LiveTradePage/LiveTradeTabs.vue";
export default {
    components: {
        LiveTradeTabs,
    },
};
</script>
